module.exports = __webpack_public_path__ + "a875fda7332e874679ff5429d9c23fa7.svg";